<header class="header">
    <div class="container">
        <div class="main-menu" [ngClass]="{active: searchActive}">
            <div class="logo">
                <h2 class="logo-item">ЛОГО</h2>
            </div>
            <ul class="menu">
                <li class="menu-item" routerLinkActive="active current" routerLink="/" [routerLinkActiveOptions]="{exact:true}">
                    <a>Главная</a>
                </li>
                <li class="menu-item"  routerLinkActive="active current" routerLink="/cards/card-catalog">
                    <a>каталог</a>
                </li>
                <li class="menu-item"  routerLinkActive="active current" routerLink="/news">
                    <a>новости</a>
                </li>
                <li class="menu-item"  routerLinkActive="active current" routerLink="/experts">
                    <a>эксперты</a>
                </li>
                <li class="menu-item"  routerLinkActive="active current" routerLink="/about-project">
                    <a>О проекте</a>
                </li>
            </ul>
        </div>
        <div class="search-content">
            <div class="search" [ngClass]="{active: searchActive}">
                <input class="search-inp" type="text" placeholder="Вино красное, урожай 2015 года">
                <button class="search-btn">
                    <i class="fas fa-search"></i>
                </button>
            </div>
            <div class="search-icons">
                <i class="fas fa-search" (click)="searchActived()" [ngClass]="{active: searchActive}"></i>
                <i class="fas fa-times-circle fa-6x" (click)="searchActived()" [ngClass]="{active: searchActive}"></i>
               </div>
        </div>
       
        <div class="register" [ngClass]="{active: searchActive}">
            <h5 class="register-title"  (click)="showModal()"><span>вход</span></h5>
            <nz-modal [(nzVisible)]="isVisible"  (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
              <ng-container *nzModalContent>
                <h3>Вход</h3>
                <p>Content two</p>
                <p>Content three</p>
              </ng-container>
            </nz-modal>
            <button class="userIcon">
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.9285 11.4809V10.3789C10.9285 9.79433 10.6778 9.23372 10.2316 8.82037C9.78548 8.40702 9.18035 8.1748 8.54937 8.1748H3.7912C3.16022 8.1748 2.55509 8.40702 2.10893 8.82037C1.66276 9.23372 1.41211 9.79433 1.41211 10.3789V11.4809"
                        stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M6.17057 5.97167C7.48449 5.97167 8.54963 4.98486 8.54963 3.76757C8.54963 2.55028 7.48449 1.56348 6.17057 1.56348C4.85665 1.56348 3.7915 2.55028 3.7915 3.76757C3.7915 4.98486 4.85665 5.97167 6.17057 5.97167Z"
                        stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

            </button>
        </div>
    </div>
</header>